import * as React from "react"
import { router } from "@inertiajs/react"
import { ArrowDown, ArrowUp } from "lucide-react"
import { Button } from "@/components/ui/button"

// Move up / Move down for an ordered list (gallery pieces, FAQs within a
// topic): phone-friendly, no drag (M7 decision 5). PATCH `direction`, keep the
// scroll; the server redirects back and the list re-renders in its new order.
export function MoveButtons({
  url,
  itemName,
  first,
  last,
}: {
  url: string
  itemName: string
  first: boolean
  last: boolean
}) {
  const [processing, setProcessing] = React.useState(false)

  const move = (direction: "up" | "down") => {
    router.patch(
      url,
      { direction },
      {
        preserveScroll: true,
        preserveState: true,
        onStart: () => setProcessing(true),
        onFinish: () => setProcessing(false),
      },
    )
  }

  return (
    <div className="flex items-center gap-1" role="group" aria-label={`Order of ${itemName}`}>
      <Button
        type="button"
        variant="secondary"
        size="icon-lg"
        disabled={first || processing}
        aria-label={`Move ${itemName} up`}
        onClick={() => move("up")}
      >
        <ArrowUp className="h-4 w-4" aria-hidden="true" />
      </Button>
      <Button
        type="button"
        variant="secondary"
        size="icon-lg"
        disabled={last || processing}
        aria-label={`Move ${itemName} down`}
        onClick={() => move("down")}
      >
        <ArrowDown className="h-4 w-4" aria-hidden="true" />
      </Button>
    </div>
  )
}
